export default "__VITE_ASSET__Pd6XSNfs__"